





























import Vue from "vue";
import { Computed, Data, Method, Props } from "./types";
import { props } from "./props";
import ChangePlanNames from "./ChangePlanNames.vue";
import PlanChangeCaptions from "./PlanChangeCaptions.vue";
import PaymentInformation from "./PaymentInformation.vue";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-about-change-plans-sb",
  components: {
    ChangePlanNames,
    PlanChangeCaptions,
    PaymentInformation
  },
  props
});
